import React, { useState, useEffect } from 'react';
import { useForm } from '@mantine/form';
import { TextInput, Button, Group, Title } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { saveTenantUser, updateTenantUser } from '../../services/api.service';
import { IconCheck } from '@tabler/icons-react';

const TenantUserForm = ({ closeModal, isEdit, user }) => {

	// Hooks
	const [isLoading, toggleLoading] = useState(false);
	const form = useForm({
		initialValues: {
			email: '',
		},
	});

	// Check if edit
	useEffect(() => {
		if (isEdit) form.setValues({
			email: user.email,
		});
		// eslint-disable-next-line
	}, []);

	// Submit form
	const onSubmit = (values) => {

		// Set loader
		toggleLoading(true);

		// Conditions
		if (!isEdit) {

			// Call API
			saveTenantUser(values, function () {

				// Show success
				notifications.show({
					title: 'Usuario creado correctamente',
					color: 'green',
					icon: <IconCheck />
				});

				// Close after 1 second
				setTimeout(() => {

					// Close modal
					closeModal();

				}, 1000);

			}, function (error) {

				// Remove preloader
				toggleLoading(false);

				// Show error
				notifications.show({
					title: 'Error',
					message: error?.message?.[0] || 'Error inesperado.',
					color: 'red'
				});

			});

		} else {

			// Call API
			updateTenantUser(user.id, values, function () {

				// Show success
				notifications.show({
					title: 'Usuario modificado correctamente',
					color: 'green',
					icon: <IconCheck />
				});

				// Close after 1 second
				setTimeout(() => {

					// Close modal
					closeModal();

				}, 1000);

			}, function (error) {

				// Remove preloader
				toggleLoading(false);

				// Show error
				notifications.show({
					title: 'Error',
					message: error?.message?.[0] || 'Error inesperado.',
					color: 'red'
				});

			});

		}

	}

	return (
		<>
			{/* Form */}
			<form onSubmit={form.onSubmit(onSubmit)}>
				{/* Title */}
				<Title
					order={5}
					mb="md"
				>
					{isEdit ? 'Modificar' : ''} Información de Usuario
				</Title>
				{/* Input Group */}
				<Group grow>
					{/* Email */}
					<TextInput
						required
						label="Correo Electrónico"
						placeholder="Correo electrónico del usuario"
						value={form.values.email}
						onChange={(event) => form.setFieldValue('email', event.currentTarget.value)}
						{...form.getInputProps('email')}
						type="email"
					/>
				</Group>
				{/* Buttons */}
				<Group
					position="apart"
					grow={!isEdit}
				>
					{/* Cancel */}
					<Button
						mt="xl"
						color="red"
						onClick={closeModal}
						disabled={isLoading}
						variant="light"
						sx={{ flexGrow: isEdit ? 2 : 1 }}
					>
						Cancelar
					</Button>
					{/* Submit */}
					<Button
						mt="xl"
						type="submit"
						loading={isLoading}
						variant="filled"
						sx={{ flexGrow: isEdit ? 2 : 1 }}
					>
						{isEdit ? 'Guardar Cambios' : 'Crear Usuario'}
					</Button>
				</Group>
			</form>
		</>
	);

}

export default TenantUserForm;
